import type { PayloadAction, Slice } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import type { AccountState } from "../types/account";

const initialState: AccountState = {
  isAuthenticated: false,
  isLoading: true,
  user: null,
  roles: [],
  permissions: [],
};

export const accountSlice: Slice<AccountState> = createSlice({
  name: "account",
  initialState,
  reducers: {
    login(state, action: PayloadAction<AccountState>) {
      state.isAuthenticated = action.payload.isAuthenticated;
      state.isLoading = action.payload.isLoading;
      state.user = action.payload.user;
      state.roles = action.payload.roles;
      state.permissions = action.payload.permissions;
    },
    logout(state, action: PayloadAction<AccountState>) {
      state.isAuthenticated = action.payload.isAuthenticated;
      state.isLoading = action.payload.isLoading;
      state.user = action.payload.user;
      state.roles = action.payload.roles;
      state.permissions = action.payload.permissions;
    },
  },
});

export const { login, logout, switchRole } = accountSlice.actions;
export default accountSlice.reducer;
